import { Component, Input, OnInit } from '@angular/core';
import { InjectQueryParam } from '@ddt-web/generic-utils';
import { SharedQueryParamKey } from '@ddt-web/url';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-tpm-disclosure',
	templateUrl: './tpm-disclosure.component.html',
	styleUrls: ['./tpm-disclosure.component.scss']
})

export class TpmDisclosureComponent implements OnInit {
	@InjectQueryParam(SharedQueryParamKey.PORTFOLIOS) private readonly portfolioIds: string[];

	@Input() public isSnapshot: boolean = false;

	public containsTpm: boolean = false;

	public ngOnInit(): void {
		this.containsTpm = this.portfolioIds?.some(id => id.includes('TPM@'));
	}
}
